import { Alert } from 'antd';
import { Button } from 'legacy-components/componets';
import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePenaltyPayments } from 'hooks/query/penalty/use-penalty-payments';
import { useMultipleEstates } from 'hooks/query/estates/use-multiple-estates';

const PenaltyPaymentAlert: FC = () => {
  const navigate = useNavigate();
  const { data: penaltiesData, isLoading, isError } = usePenaltyPayments();

  // Use only individual penalties for now
  const penalties = penaltiesData?.individualPenalties || [];
  const unpaidPenalties = penalties.filter(penalty => !penalty.isPaid);

  // Get unique estate IDs from unpaid penalties
  const estateIds = useMemo(() => {
    return [...new Set(unpaidPenalties.map(p => p.estateId).filter(Boolean))] as string[];
  }, [unpaidPenalties]);

  // Fetch estate data for all unique estate IDs
  const { estateDataMap } = useMultipleEstates(estateIds);

  // Get property addresses using actual estate data
  const propertyAddresses = useMemo(() => {
    return unpaidPenalties.map(penalty => {
      const estate = estateDataMap.get(penalty.estateId || '');
      if (estate) {
        const parts = [estate.street, estate.city, estate.state, estate.zipcode].filter(Boolean);
        return parts.length > 0 ? parts.join(', ') : 'Address unavailable';
      }
      return 'Address unavailable';
    });
  }, [unpaidPenalties, estateDataMap]);

  // Early returns after all hooks
  if (isLoading) {
    return null;
  }

  if (isError || penalties.length === 0) {
    return null;
  }

  if (unpaidPenalties.length === 0) {
    return null;
  }

  const totalUnpaidAmount = unpaidPenalties.reduce((sum, penalty) => sum + (penalty.penaltyAmount || 0), 0);
  const penaltyCount = unpaidPenalties.length;

  const handleViewPenalties = () => {
    navigate('/i-landlord/profile/info/penalties');
  };

  return (
    <Alert
      description={
        <div className='flex flex-col items-center'>
          <div className={'mb-4 text-[#6C6C6C]'}>
            This is a notice that service fees have been incurred due to lease agreements not being countersigned within the required 
            48-hour window following renter acceptance. This is a violation of Axxelist's policy as outlined in our Terms and Conditions. 
            The following units are subject to a $150 service fee each for a total of service fee Due [${(totalUnpaidAmount || 0).toFixed(2)}]: {propertyAddresses.join(', ')}
            <br /><br />
            To maintain access to Axxelist's services, the total fee must be paid promptly. If you have any questions or need assistance, 
            feel free to contact our support team.
          </div>
          <div className="flex gap-3">
            <Button
              label={`Pay [$${totalUnpaidAmount.toFixed(2)}] Service Fees`}
              onClick={handleViewPenalties}
              className={'bg-[#FF9500] text-[#FFFFFF]'}
              disabled={false}
              isLoading={false}
            />
          </div>
        </div>
      }
      type='warning'
      className='mb-4'
    />
  );
};

export { PenaltyPaymentAlert };
